@if (showPrevious()) {
    <div class="arrow-left cursor-pointer" (click)="previousSelect.emit()">
        <span class="arrow-icon-left d-none d-lg-block"></span>
        <fa-icon class="d-block d-lg-none" [icon]="faChevronLeft"></fa-icon>
    </div>
}
@if (showNext()) {
    <div class="arrow-right cursor-pointer" (click)="nextSelect.emit()">
        <span class="arrow-icon-right d-none d-lg-block"></span>
        <fa-icon class="d-block d-lg-none" [icon]="faChevronRight"></fa-icon>
    </div>
}
